<template>
  <div class="pre_content">
    <div class="pre_title">
      <span>我的接待</span>
      <span @click="checkMore(4)">查看更多>></span>
    </div>
    <div class="my_finish">
      <div class="finishImg" @click="checkMore(1)">
        <van-badge :content="countDw">
          <img src="../../../assets/icon/waitting.png" alt="">
        </van-badge>
        <div>待接待</div>
      </div>
      <div class="finishImg" @click="checkMore(2)">
        <van-badge :content="countYw">
          <img src="../../../assets/icon/reception.png" alt="">
        </van-badge>
        <div>接待中</div>
      </div>
      <div class="finishImg" @click="checkMore(3)">
        <van-badge :content="countYq">
          <img src="../../../assets/icon/finish.png" alt="">
        </van-badge>
        <div>接待完成</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      countDw: 1,
      countYw: 2,
      countYq: 4,
    }
  },
  methods: {
    // 点击查看更多跳转
    checkMore(val) {
      this.$router.push({
        name: "allCustomer",
        params: {
          val: val
        },
      });
    },
  }
}
</script>
<style scoped>
@import "../../../assets/css/aboutUs.css";
</style>


// WEBPACK FOOTER //
// src/components/page/aboutChild/aboutCustomer.vue